import React from "react";
import { Button } from "@material-ui/core";
import shortfetch from "../../../components/data/fetch";

const AddNewModel = (props) => {
  const { history, Change_State, ModelID, max } = props;

  const add_new_model = async () => {
    let post_json = {
      type: "add_new_model",
      currentID: ModelID,
      auth: localStorage.getItem("auth"),
    };

    let data = await shortfetch(post_json);

    let succes;

    if (data.geslaagd) {
      let newID = Number(max) + 1;
      history.push("/Form/Modellen/" + newID);
      Change_State(newID);
    } else {
      succes = "Er is iets fout gegaan tijdens het opslaan.";
    }

    alert(succes);
  };

  return (
    <Button onClick={() => add_new_model()} style={{ background: "white" }}>
      Nieuw Model Toevoegen
    </Button>
  );
};

export default AddNewModel;
